"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));
var texts = {
  sm: {
    "default": 'text-sm',
    main: 'text-3xl'
  },
  md: {
    "default": 'text-lg',
    main: 'text-6xl leading-tight'
  }
};
var sizes = {
  sm: 'px-6',
  md: ''
};
var HeroText = function HeroText(_ref) {
  var size = _ref.size,
    label = _ref.label,
    text = _ref.text,
    subText = _ref.subText;
  var textClasses = (0, _get["default"])(texts, size, texts.md);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('font-bold text-dark', textClasses["default"])
  }, /*#__PURE__*/_react["default"].createElement("div", null, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: textClasses.main
  }, text), /*#__PURE__*/_react["default"].createElement("div", null, subText));
};
var View = function View(_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'md' : _ref2$size,
    from = _ref2.from,
    to = _ref2.to;
  var sizeClasses = (0, _get["default"])(sizes, size, sizes.md);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex items-center py-4', sizeClasses)
  }, /*#__PURE__*/_react["default"].createElement(HeroText, {
    size: size,
    label: from.label,
    text: from.text,
    subText: from.subText
  }), !(0, _isNil["default"])(to) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-10"
  }, /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], null)), /*#__PURE__*/_react["default"].createElement(HeroText, {
    size: size,
    label: to.label,
    text: to.text,
    subText: to.subText
  })));
};
View.displayName = 'HeroBoard';
var _default = exports["default"] = View;
//# sourceMappingURL=HeroBoard.js.map